import React from "react";

import "./styles.scss";
import { Title, TYPES } from "@propellerads/title";

const PageNotFound = (props) => {
  return (
    <div className="PageNotFound">
      <div className="PageNotFound__content">
        <div className="PageNotFound__content-row">
          <div className="PageNotFound__smile">
            <span role="img" aria-label="Neutral Face">
              😐
            </span>
          </div>
          <Title type={TYPES.H1}>Oops! Something went wrong.</Title>
          <p className="PageNotFound__body">
            Please go to <a href="/">homepage</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
